const config = {
  basePath: '/' + (process.env.REACT_APP_URL_PREFIX || ''),
  apiURL: `${process.env.PUBLIC_URL}/api`,
  appName: 'EMERGENCY_NEWS_FEED',
  googleAnalyticsId: 'G-5B60S5J9TS',
};

export default config;
